import { createContext } from 'react';
import moment from 'moment';

const defaultValue = {
  schedule: null,
  mapData: null,
  setMapData: () => {},
  dispatchDate: moment().format('YYYY-MM-DD'),
  setDispatchDate: () => {},
  handleDate: () => {},
  loading: true,
  reOrdered: false,
  setReOrdered: () => {},
  isEditing: false,
  setIsEditing: () => {},
};

export const DispatchContext = createContext(defaultValue);
export const DispatchProvider = DispatchContext.Provider;
export const DispatchConsumer = DispatchContext.Consumer;
